<template>
    <div class="home-intelligentDevice" ref="container">
      <div class="content" :style="conHeight">
        <div class="contents">
            <el-row :gutter='10'>
                <el-col :span='6'>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>智能安防设备</span>
                        </div>
                        <div style="height:100%">
                            <template>
                            <el-table
                                :data="tableData"
                                stripe
                                style="width: 100%" height="80%">
                                <el-table-column
                                prop="name"
                                label="设备名称">
                                </el-table-column>
                                <el-table-column
                                prop="number"
                                label="设备数量">
                                </el-table-column>
                                <el-table-column
                                prop="in"
                                label="设备在线">
                                </el-table-column>
                                <el-table-column
                                prop="out"
                                label="设备离线">
                                </el-table-column>
                            </el-table>
                        </template>
                        </div>
                    </div>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>报警总数</span>
                            <span>报警总数：8916</span>
                        </div>
                        <div id="callPolice" class="echarts" style="height:90%"></div>
                    </div>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>月度报警趋势</span>
                        </div>
                        <div id="tendency" class="echarts" style="height:90%"></div>
                    </div>
                </el-col>
                <el-col :span='12'>
                    <baidu-map :center="map.center"  :mapClick="false" @ready="handler" :zoom="map.zoom" style="height:52vh;overflow:hidden;min-height:380px;margin-bottom:1.5vh" :scroll-wheel-zoom='true'>
                        <bml-marker-clusterer :averageCenter="true" >
                        <bm-marker v-for="(it,index) in ms"
                            :key="index"
                            :position="it.position"
                            @click="markclick(it,index)"
                            @mouseover="markover(it,index)">
                            <bm-info-window
                                :position="it.position">
                                <p v-text="it.mess"></p>
                            </bm-info-window>
                        </bm-marker>
                        </bml-marker-clusterer>
                    </baidu-map>
                    <el-col :span='12'>
                        <div class="intelligentDeviceBox" style="height: 30vh;min-height:230px;">
                            <div class="title">
                                <span>一周报警数量动态</span>
                            </div>
                            <div id="alarmNumber" class="echarts" style="height:80%"></div>
                        </div>
                    </el-col>
                    <el-col :span='12'>
                        <div class="intelligentDeviceBox" style="height: 30vh;min-height:230px;">
                            <div class="title">
                                <span>最新报警信息列表</span>
                            </div>
                            <div style="height:80%">
                                <div class="jbtop">
                                    <i class="el-icon-circle-check"></i><span>已处理</span>
                                    <div style="">80%</div>
                                </div>
                                <div class="popess">
                                    <div style="width:80%">
                                        <div class="popess1"></div>
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableData1"
                                        :show-header='false'
                                        stripe
                                        style="width: 100%;margin-top:10px;padding:0 5%" height="70%">
                                        <el-table-column
                                        prop="type" width="80">
                                        </el-table-column>
                                        <el-table-column
                                        prop="name" width="80">
                                        </el-table-column>
                                        <el-table-column
                                        prop="createTime"
                                         width="150">
                                        </el-table-column>
                                        <el-table-column
                                        prop="status"
                                         width="80">
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </div>
                        </div>
                    </el-col>
                </el-col>
                <el-col :span='6'>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>实时报警信息</span>
                        </div>
                        <div style="height:100%">
                            <template>
                                <el-table
                                    :data="tableData2"
                                    stripe
                                    style="width: 100%" height="80%">
                                    <el-table-column
                                    prop="name"
                                    label="姓名"
                                    width="80">
                                    </el-table-column>
                                    <el-table-column
                                    prop="phone"
                                    label="电话"
                                    width="120">
                                    </el-table-column>
                                    <el-table-column
                                    prop="createTime"
                                    label="时间"
                                    width="150">
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="success" size="small" @click.native.prevent="handle(scope.$index, scope.row)">处理</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                    </div>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>今日报警</span>
                        </div>
                        <div id="alarmToday" class="echarts" style="height:80%"></div>
                    </div>
                    <div class="intelligentDeviceBox">
                        <div class="title">
                            <span>报警处理分析</span>
                        </div>
                        <div id="itt" class="echarts" style="height:80%"></div>
                    </div>
                </el-col>
            </el-row>

        </div>
    </div>
    </div>
</template>

<script>
    // import mapvgl from 'mapvgl'
    import jiankong from './img/jiankong.png'
    // import 'element-ui/lib/theme-chalk/base.css';
    import { BmlMarkerClusterer } from 'vue-baidu-map'
    import { getInsNameByDomainName } from '@/utils/auth'
    import styleJson from "@/common/custom_map_config.json"
    // import numberScroll from "@/components/DigitalScroll.vue";
    export default {
        name: "Home",
        data(){
            return{
                nextPersonNum:2000,
                jiankong:jiankong,
                tableData2:[{
                    name: '王林',
                    phone: '13516486889',
                    createTime:'2020-05-31 12:30'
                  },{
                    name: '钱弘',
                    phone: '18748486895',
                    createTime:'2020-05-03 08:30'
                  },{
                    name: '李景崖',
                    phone: '13616846689',
                    createTime:'2020-04-23 18:30'
                  },{
                    name: '吴二白',
                    phone: '15598956354',
                    createTime:'2019-11-23 13:56'
                  },{
                    name: '周治',
                    phone: '18254688968',
                    createTime:'2019-09-03 14:38'
                  }
                ],
                tableData:[{
                    name: '安防主机',
                    number: '15',
                    in: '13',
                    out:'2'
                  },{
                    name: '燃气探测器',
                    number: '23',
                    in: '22',
                    out:'1'
                  },{
                    name: '烟雾探测器',
                    number: '35',
                    in: '35',
                    out:'0'
                  },{
                    name: '水浸探测器',
                    number: '38',
                    in: '37',
                    out:'1'
                  }
                ],
                tableData1:[{
                        type:'燃气报警',
                        name:'李梅',
                        createTime:'2020-05-31 12:30',
                        status:'未处理'
                    },{
                        type:'烟雾报警',
                        name:'王浩',
                        createTime:'2020-05-03 08:30',
                        status:'未处理'
                    },{
                        type:'水浸报警',
                        name:'钱弘',
                        createTime:'2020-04-23 18:30',
                        status:'已处理'
                    },{
                        type:'水浸报警',
                        name:'李景崖',
                        createTime:'2019-11-23 13:56',
                        status:'未处理'
                    },{
                        type:'烟雾报警',
                        name:'孙贰佰',
                        createTime:'2019-10-03 08:30',
                        status:'未处理'
                    },{
                        type:'燃气报警',
                        name:'周治',
                        createTime:'2019-09-03 14:38',
                        status:'已处理'
                    }],
                map:{
                  center:{lng: 114.023598, lat: 33.589299},
                  zoom:5,
                },
                show2:true,
                callPolice:'',
                tendency:'',
                alarmNumber:'',
                alarmToday:'',
                itt:'',
                ms:[],
                mapStyle:{
                  styleJson: styleJson
                },
                conHeight:{
                    height:''
                }
            }
        },
        mounted(){
            this.$nextTick(()=>{ // 页面渲染完成后的回调
                this.conHeight.height=this.$refs.container.offsetHeight-100+'px'
            })
            var that=this
            // setInterval(function () {
            //     that.show2=!that.show2
            // }, 1000);
            this.init()

            window.addEventListener("resize", () => {
                that.callPolice.resize();
                that.tendency.resize();
                that.alarmNumber.resize();
                that.alarmToday.resize();
                that.itt.resize();
            });
        },
        components:{BmlMarkerClusterer},
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(){
                this.conHeight.height=this.$refs.container.offsetHeight-100+'px'
            },
        },

        methods:{
          handler({map }){
            map.setMapStyleV2({
              styleId: '5c78974534ede0f3d27c313340264e0b'
            });
          },
            init(){
                this.$store.commit('update', ['title',getInsNameByDomainName()+'智能设备']);
                this.getCallPolice()
                this.getTendency()
                this.getAlarmNumber()
                this.getAlarmToday()
                this.getItt()
                for (var i =0; i < 78; i++) {
                    var aaa = this.selectFrom(114,117)+Math.random();
                    var bbb = this.selectFrom(30,40)+Math.random();
                    var lo={position:{
                            lng:aaa,
                            lat:bbb
                        },
                        mess:'测试',
                        show:true};
                    this.ms.push(lo);
                }
            },
            markclick(){

            },
            markover(){

            },
            getItt(){
                this.itt = this.$echarts.init(document.getElementById('itt'))
                var option={
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    legend: {
                        data: ['已解决', '未解决'],
                        align: 'right',
                        top:10,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    grid: [{
                        left: '10%',
                        right: '1%',
                        bottom: '10%',
                        top: '20%',
                    }
                    ],
                    xAxis: [
                        {type: 'category',
                        data: ['水浸报警', '烟雾报警', '燃气报警'],
                        splitNumber: 6,
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(18, 114, 189, 1)',
                            },
                        },
                        axisLabel: {
                            interval: 0,
                            color:'#fff'
                        }
                    }],
                    yAxis: [{
                        type: "value",
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            lineStyle: {
                                color: 'rgba(18, 114, 189, 1)',
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(18, 114, 189, 1)',
                            }
                        },
                        axisLabel:{
                            color:'#fff'
                        }
                    }],
                    series: [
                        {
                            name:"已解决",
                            type: 'bar',
                            barWidth:'30',
                            itemStyle: {
                                normal: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: "#EE7E1B"
                                        },
                                        {
                                            offset: 1,
                                            color: '#EEC91B'
                                        }
                                    ]),
                                }
                            },
                            data: [10, 52, 200]},
                        {
                            name:"未解决",
                            type: 'bar',
                            barWidth:'30',
                            itemStyle: {
                                normal: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: "#0065D7"
                                        },
                                        {
                                            offset: 1,
                                            color: '#00FCFF'
                                        }
                                    ]),
                                }
                            },
                            data: [3, 22, 12]
                        }

                    ]
                }
                this.itt.setOption(option)
            },
            getAlarmToday(){
                this.alarmToday = this.$echarts.init(document.getElementById('alarmToday'))
                var option = {
                     tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        top:'3%',
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        axisLine: {
                            show: true,
                            onZero: true,
                            lineStyle: {
                            color:'#00A0E9'
                            }
                        },
                        axisLabel: {
                            fontSize: 15,
                            color: "#fff"
                        },
                        axisTick: {
                            show: true,
                            inside: true,
                            color: "#00A0E9"
                        },
                        splitLine: {
                            show:false,
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: ['燃气报警', '烟雾报警', '水浸报警'],

                        splitLine: {
                            show:false,
                        },
                        axisLine: {
                            show: true,
                            onZero: true,
                            lineStyle: {
                            color: "#00A0E9"
                            }
                        },
                        axisLabel: {
                            fontSize: 15,
                            color:'#fff'
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    series: [
                        {
                            name: '2011年',
                            type: 'bar',
                            barWidth:30,
                            data: [2, 1, 5],
                            itemStyle: {
                                normal: {
                                color: function (params) {
                                    var colorList = ['rgba(255, 96, 59, 1)', 'rgba(21, 214, 116, 1)', 'rgba(115, 88, 252, 1)'];
                                    return colorList[params.dataIndex]
                                },
                                }
                            }
                        }
                    ]
                };
                this.alarmToday.setOption(option)
            },
            getAlarmNumber(){
                this.alarmNumber = this.$echarts.init(document.getElementById('alarmNumber'))
                var data=[]
                var data1=[]
                var data2=[]
                for(var i=0;i<7;i++){
                    data.push(this.selectFrom(1,10))
                    data1.push(this.selectFrom(1,10))
                    data2.push(this.selectFrom(1,10))
                }
                var option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            lineStyle: {
                                color: '#57617B'
                            }
                        }
                    },
                    legend: {
                        data: ['燃气报警', '烟雾报警', '水浸报警'],
                        right: '4%',
                        top:'8%',
                        textStyle: {
                            fontSize: 12,
                            color: '#F1F1F3'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:'20%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: '#1272BD'
                            }
                        },
                         axisLabel: {
                            textStyle: {
                                fontSize: 14,
                                color: '#fff'
                            }
                        },
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    }],
                    yAxis: [{
                        type: 'value',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#1272BD'
                            }
                        },
                        axisLabel: {
                            margin: 10,
                            textStyle: {
                                fontSize: 14,
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#1272BD'
                            }
                        }
                    }],
                    series: [{
                        name: '燃气报警',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(137, 189, 27, 0.3)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(137, 189, 27, 0)'
                                }], false),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(137,189,27)'
                            }
                        },
                        data:data
                    }, {
                        name: '烟雾报警',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(0, 136, 212, 0.3)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(0, 136, 212, 0)'
                                }], false),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,136,212)'
                            }
                        },
                        data:data1
                    }, {
                        name: '水浸报警',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(219, 50, 51, 0.3)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(219, 50, 51, 0)'
                                }], false),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(219,50,51)'
                            }
                        },
                        data: data2
                    }, ]
                };
                this.alarmNumber.setOption(option)
            },
            selectFrom(iFirstValue,iLastValue){
                var iChoces = Math.abs(iLastValue - iFirstValue)+1;
                return Math.floor(Math.random() * iChoces + iFirstValue);
            },
            getTendency(){
                this.tendency = this.$echarts.init(document.getElementById('tendency'))
                var data=[]
                var datas=[]
                for(var i=0;i<30;i++){
                    if(i+1<10){
                        datas.push('0'+(i+1))
                    }else{
                        datas.push(i+1)
                    }
                    data.push(this.selectFrom(0,10))
                }
                var option = {
                    xAxis: {
                        type: 'category',
                        data:datas,
                        axisLine: {
                            show: true,
                            onZero: true,
                            lineStyle: {
                            color: "#00A0E9"
                            }
                        },
                        axisLabel: {
                            fontSize: 15,
                            color:'#fff'
                        },
                        axisTick: {
                            show: false,
                        }
                    },
                    grid: {
                        top: "15%",
                        left: "10%"
                    },
                    yAxis: {
                        type: 'value',
                            axisLine: {
                            show: true,
                            onZero: true,
                            lineStyle: {
                            color:'#00A0E9'
                            }
                        },
                        axisLabel: {
                            fontSize: 15,
                            color: "#fff"
                        },
                        axisTick: {
                            show: true,
                            inside: true,
                            color: "#00A0E9"
                        },
                        splitLine: {
                            show:false,
                        },
                    },
                    series: [{
                        data:data,
                        type: 'line',
                        smooth: true
                    }]
                };

                this.tendency.setOption(option)
            },
            getCallPolice(){
                this.callPolice = this.$echarts.init(document.getElementById('callPolice'))
              var option = {
                xAxis: {
                  type: 'category',
                  data: ['燃气报警', '烟雾报警 ','水浸报警'],
                  axisLine: {
                    show: true,
                    onZero: true,
                    lineStyle: {
                      color: "#00A0E9"
                    }
                  },
                  axisLabel: {
                    fontSize: 15,
                    color:'#fff'
                  },
                  axisTick: {
                    show: false,
                  }
                },
                grid: {
                  top: "15%",
                  left: "10%"
                },
                yAxis: {
                  type: 'value',
                  name:'（次）',
                  axisLine: {
                    show: true,
                    onZero: true,
                    lineStyle: {
                      color:'#00A0E9'
                    }
                  },
                  axisLabel: {
                    fontSize: 15,
                    color: "#fff"
                  },
                  axisTick: {
                    show: true,
                    inside: true,
                    color: "#00A0E9"
                  },
                  splitLine: {
                    show:false,
                  },

                },

                series: [{
                  data: [192, 80,50],
                  type: 'bar',
                  barWidth: "30",
                  label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    color: "rgba(255,255,255,1)",
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        var colorList = ['#00A0E9', '#F3D459', '#FF603B'];
                        return colorList[params.dataIndex]
                      },
                    }
                  }

                }]

              };
              this.callPolice.setOption(option)
            }
        }

    }


</script>

<style lang="scss"  scoped>
    .home-intelligentDevice {
        width: 100%;
        height:100vh;
        margin-top: -75px;
        background-image: url(./img/background.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center top;
        min-width: 1360px;
        min-height: 736px;
        .modal{
          height: 480px;
          position: relative;
          img{
            height: 113%;
            width: 104.5%;
            top: -30px;
            left: -20px;
            position: absolute;
          }
          div{
            position: relative;
          }
        }

        .content{
            height: 100%;
            margin: 0;
            padding: 0;
            padding:0 1.6vw;
            padding-top: 100px;
        }
        .contents{
            min-width: 1220px;
            height: 100%;
            .intelligentDeviceBox{
                height: 27vh;
                min-height: 200px;
                background:rgba(3,25,83,1);
                border:1px solid rgba(1,118,172,1);
                border-radius:10px;
                margin-bottom: 1vh;
                position: relative;
                overflow: hidden;
                .ranqi{
                    color:white;
                    text-align:center;
                    padding: 5px 5%;
                    div:nth-child(1){
                        width: 22%;
                        display: inline-block;
                    }
                    div:nth-child(2){
                        width: 20%;
                        display: inline-block;
                    }
                    div:nth-child(3){
                        width: 40%;
                        display: inline-block;
                    }
                    div:nth-child(4){
                        width: 20%;
                        color: red;
                        display: inline-block;
                    }
                }
                .jbtop{
                    // width: 100%;
                    margin-top: 2%;
                    color: rgba(0, 255, 255, 1);
                    padding:0 5%;
                    div{
                        float: right;
                    }
                }
                .title{
                    // width: 100%;
                    padding: 5px 20px;
                    font-size: 18px;
                    font-family:Microsoft YaHei;
                    font-weight:bold;
                    color:rgba(0,255,255,1);
                    line-height:30px;
                    border-bottom: 1px solid rgba(43, 59, 118, 1);
                }
                .popess{
                    width: 90%;
                    background: #323F62;
                    border-radius: 15px;
                    height: 15px;
                    margin-left: 5%;
                    margin-top: 10px;
                    overflow: hidden;
                }
                .popess1{
                    background-image: linear-gradient(to right, #4635F3 , #4BF6EE);
                    border-radius: 15px;
                    height: 15px;
                    animation:mymove 2s normal forwards ease-in-out;
                }
                @keyframes mymove{
                    from {width: 0%;}
                    to {width: 100%;}
                }
                /deep/ .el-table {
                    background-color:transparent;
                }
                .el-table::before {
                    height: 0px;
                }
                ::v-deep .el-table th,
                ::v-deep .el-table td {
                    text-align: center !important;
                }
                /deep/ .el-table th {
                    background-color:transparent;
                }
                /deep/ .el-table__row td{
                    border: none;
                }
                /deep/ .el-table__header tr {
                  background-image: linear-gradient(to right,rgba(1, 125, 252, 1),rgba(5, 140, 255, 0.01));
                  background-color: transparent;
                }
                 /deep/ .el-table__body .el-table__row{
                     background-color: transparent;
                }
                 /deep/ .el-table__body .el-table__row--striped td{
                     background-color:transparent;
                }
                /deep/ .el-table th.is-leaf {
                  border: 0;
                }
                /deep/ .el-table__header .cell {
                    color: rgba(28, 252, 255, 1);
                }
                /deep/ .el-table td div {
                    color: rgba(161, 212, 255, 1);
                }
                /deep/  .el-table__body{
                    width: 100% !important;
                }
                /deep/ .el-table__header .gutter{
                    display: none !important;
                }
                /deep/ .el-table tbody tr:hover>td {
                    background-color:transparent!important
                }
                /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 17px;}
                /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    display: none;
                    background: #00FFFF;
                }
                /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
                    border-radius: 0;
                    background: transparent;
                }
            }
        }


    }

</style>
